<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="d-sm-none d-flex justify-content-between">
    <label class="col-form-label" for="email{{index}}">
      <span>{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.EMAIL' | translate }}</span>
    </label>
    <common-ui-daten-uebernahme (picked)="form.get('email').setValue($event)"
                                [itemTemplate]="datenuebernahmeEmailadresse"
                                [items]="stammdatenEmailadressen" [readonly]="readonly"
                                context="Emailadresse{{index}}Xs"></common-ui-daten-uebernahme>
  </div>
  <div class="form-row">
    <label class="d-none d-sm-inline col-sm-3 col-form-label" for="email{{index}}">
      <span class="d-flex justify-content-between">
        <span>{{ 'COMMON_UI.KOMMUNIKATIONSMITTEL.EMAIL' | translate }}</span>
      </span>
    </label>
    <div class="d-none d-sm-flex col-sm-1 common-ui-small-stammdaten-button">
      <common-ui-daten-uebernahme (picked)="form.reset($event)"
                                  [itemTemplate]="datenuebernahmeEmailadresse"
                                  [items]="stammdatenEmailadressen" [readonly]="readonly"
                                  context="Emailadresse{{index}}" imageOnly="true"></common-ui-daten-uebernahme>
    </div>
    <div class="col-sm-8">
      <ng-container *ngIf="require">
        <input class="form-control" datevMessagePath="email{{objectId}}" formControlName="email" id="email{{index}}"
               type="text" utilsCheckValidity utilsMarkRequired
               utilsControlState utilsValidationMessage/>
      </ng-container>
      <ng-container *ngIf="!require">
        <input class="form-control" datevMessagePath="email{{objectId}}" formControlName="email" id="email{{index}}"
               type="text" utilsCheckValidity
               utilsControlState utilsValidationMessage/>
      </ng-container>

    </div>
  </div>
</form>

<ng-template #datenuebernahmeEmailadresse let-item="item">
  <h4 class="list-group-item-heading">{{item.email}}</h4>
  <p *ngIf="item.notiz" class="list-group-item-text">{{item.notiz}}</p>
</ng-template>
